var _defs, _path, _rect, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56.51 47.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.53,55.4A9.54,9.54,0,0,1,3,45.86V26.75a9.55,9.55,0,0,1,9.54-9.55H50a9.54,9.54,0,0,1,9.54,9.64l-.18,19.07a9.58,9.58,0,0,1-9.53,9.45l-37.24,0Zm0-35.75a7.11,7.11,0,0,0-7.1,7.1V45.86a7.1,7.1,0,0,0,7.1,7.1h0l37.23-.05a7.12,7.12,0,0,0,7.09-7l.19-19.06A7.09,7.09,0,0,0,50,19.65Z",
    transform: "translate(-2.99 -7.44)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 30.02,
    y: -0.24,
    width: 2.45,
    height: 54.06,
    transform: "translate(1.42 50.55) rotate(-89.91)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.71,50.21a5.87,5.87,0,1,1,5.87-5.87A5.88,5.88,0,0,1,48.71,50.21Zm0-9.29a3.43,3.43,0,1,0,3.43,3.42A3.42,3.42,0,0,0,48.71,40.92Z",
    transform: "translate(-2.99 -7.44)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.67,19.68h0a1.22,1.22,0,0,1-1.22-1.22A8.33,8.33,0,0,0,45.26,11a7.44,7.44,0,0,0-6.36-.68L12.19,19.58a1.22,1.22,0,1,1-.8-2.31L38.1,8a9.88,9.88,0,0,1,8.45.91,10.78,10.78,0,0,1,5.35,9.56A1.23,1.23,0,0,1,50.67,19.68Z",
    transform: "translate(-2.99 -7.44)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.afd60b7e3d05699cf8ba5cc187015fae.svg";
export { ForwardRef as ReactComponent };